import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import type { ListPagesPartProps, ActionCard } from "./ListPages.d";

function ActionCard({ title, description, url, backgroundColor }: ActionCard) {
  const external = !!url?.match(/^https?:/);
  return (
    <a
      className={`action-card ${backgroundColor} `}
      href={url}
      target={external ? "_blank" : undefined}
      rel={external ? "noreferrer" : undefined}
    >
      <h3>{title}</h3>
      {description && <div>{description}</div>}
    </a>
  );
}

export const ListPagesPart = (props: ComponentProps<PartData>) => {
  const { container, listActionCards } =
    (props.data as ListPagesPartProps) ?? {};

  return (
    <div className={`two-column-layout ${container}`}>
      {listActionCards.map((item, idx) => (
        <ActionCard
          key={idx}
          title={item.title}
          description={item.description}
          url={item.url}
          backgroundColor={item.backgroundColor}
        />
      ))}
    </div>
  );
};

export default ListPagesPart;
